import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {CONFIG} from "../../../app/config";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TAction} from "../../../app/enum";


@Component({
    selector: 'page-showtalk',
    templateUrl: 'showtalk.html'
})
export class ShowtalkPage {

    TAction: any = TAction;

    config: any;

    paused: boolean;
    timeset: string;
    timenow: Date;
    timeout: number;
    blink: boolean;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util) {

        this.config = CONFIG;

        this.paused = false;
        this.timeset = '00:02:00';

        this.start();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showtalk', '/showtalk');

        this.prepareLoad();
    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    prepareLoad() {

        setInterval( () => {

            if (this.paused) return;


            this.blink = (this.timenow.getMinutes() == 0 && this.timenow.getSeconds() <= 10 && this.timenow.getSeconds() > 1);
            let finish = (this.timenow.getMinutes() == 0 && this.timenow.getSeconds() == 0);

            if (finish && this.timeout > 0) {
                this.timeout = this.timeout - 1;
                return;
            }

            if (finish && this.timeout == 0) this.start();
            if (!finish) this.timenow.setSeconds(this.timenow.getSeconds() - 1);

        }, 1000);

    }

    start() {

        let datestr = '2000-01-01 ' + this.timeset;
        this.timenow = new Date(datestr.replace(' ', 'T'));
        this.timeout = 5;

    }

    nowtime(time: string) {

        this.paused = true;
        this.timeset = time;
        this.start();

    }

    settime() {

        //Continue
        if (this.paused) {
            this.paused = false;
            return;
        }


        /** TIME **/
        let buttons: Array<any> = [];
        buttons.push({text: '2 minutos', handler: () => this.nowtime('00:02:00')});
        buttons.push({text: '3 minutos', handler: () => this.nowtime('00:03:00')});
        buttons.push({text: '5 minutos', handler: () => this.nowtime('00:05:00')});
        buttons.push({text: '10 minutos', handler: () => this.nowtime('00:10:00')});
        buttons.push({text: '15 minutos', handler: () => this.nowtime('00:15:00')});
        this.util.sheetOpen(buttons, 'TEMPO');

    }

    dismiss() {

        this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showtalk/showtalk.ts